/**
 * Perzo mark: two prints hung side by side — the shopper's photo (outlined) and the
 * finished art (iris). It is the product mechanism reduced to two rectangles.
 */
export function BrandMark({ size = 22, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className ? `brandmark ${className}` : 'brandmark'}
      width={Math.round((size * 28) / 22)}
      height={size}
      viewBox="0 0 28 22"
      aria-hidden="true"
      focusable="false"
    >
      <rect x="1" y="5.5" width="10.5" height="14" fill="none" stroke="currentColor" strokeWidth="1.6" />
      <rect x="14" y="1" width="13" height="18.5" className="brandmark__art" />
    </svg>
  );
}

/** Wordmark set in Archivo with tuned spacing; the mark precedes it. */
export function Wordmark({ large }: { large?: boolean }) {
  return (
    <span className={large ? 'wordmark wordmark--lg' : 'wordmark'}>
      <BrandMark size={large ? 28 : 20} />
      <span className="wordmark__text" aria-hidden="true">perzo</span>
      <span className="visually-hidden">Perzo</span>
    </span>
  );
}

/** Wordmark plus an optional area label (e.g. "Admin"). */
export function BrandLockup({ subtitle, large }: { subtitle?: string; large?: boolean }) {
  return (
    <span className="lockup">
      <Wordmark large={large} />
      {subtitle ? <span className="lockup__area">{subtitle}</span> : null}
    </span>
  );
}
